import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Space } from 'antd';

import { usersApi } from 'api';
import { QuerySelectionCollapse } from 'components';
import { getRoute } from 'utils';
import { onFilterChange } from 'hooks';
import { CircleCheck } from 'icons';

import { AccessLevelsLabels } from 'components/MainLayout/utils';
import { AccessLevelsPageFiltersValue } from '../pages/AccessLevelsPage';

interface AccessLevelsMenuSectionInterface {
  onChange?: onFilterChange<AccessLevelsPageFiltersValue>;
}

export const AccessLevelsMenuSection = ({ onChange }: AccessLevelsMenuSectionInterface) => {
  const { t } = useTranslation();
  const params = useParams<{ domain: string }>();

  return (
    <QuerySelectionCollapse
      title={
        <Space size={4} styles={{ item: { display: 'flex' } }}>
          <CircleCheck /> {t('status').toUpperCase()}
        </Space>
      }
      query={usersApi.getAccessLevelsStats}
      paramsKey="access_levels_state"
      route={getRoute('AccessLevelsPage', params)}
      translates={AccessLevelsLabels}
      onChange={onChange}
    />
  );
};
